import React from "react";

const BGStep2: React.FC<React.SVGProps<SVGSVGElement>> = ({
    width,
    height,
}) => {
    return (
        <svg
        width={width}
        height={height}
        viewBox="0 0 296 192"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2070_1380)">
          <path
            d="M10 171.033C10 174.67 12.9544 177.619 16.5989 177.619H277.407C281.051 177.619 284.006 174.67 284.006 171.033V13.5862C284.006 9.94873 281.051 7 277.407 7H16.5989C12.9544 7 10 9.94873 10 13.5862V171.033Z"
            fill="white"
          />
          <path
            d="M16.599 177.414C13.0684 177.414 10.2063 174.557 10.2063 171.033V13.5864C10.2063 10.0627 13.0684 7.20605 16.599 7.20605H277.407C280.937 7.20605 283.8 10.0627 283.8 13.5864V171.033C283.8 174.557 280.937 177.414 277.407 177.414H16.599Z"
            stroke="#94A3B8"
            strokeWidth="0.5"
          />
        </g>
        <path
          d="M145.726 79C146.127 79 146.511 79.1442 146.794 79.4034C147.078 79.6608 147.237 80.0113 147.237 80.3746V83.1255C147.237 83.4906 147.078 83.8392 146.794 84.0984C146.511 84.3558 146.127 84.5 145.726 84.5H26.3114C25.9105 84.5 25.526 84.3558 25.2425 84.0984C24.9591 83.8392 24.7998 83.4906 24.7998 83.1255V80.3746C24.7998 80.0113 24.9591 79.6608 25.2425 79.4034C25.526 79.1442 25.9105 79 26.3114 79H145.726Z"
          fill="#CBE3FF"
        />
        <path
          d="M219.368 39C220.013 39 220.632 39.1304 221.087 39.3649C221.544 39.5993 221.8 39.9188 221.8 40.25V42.75C221.8 42.9141 221.737 43.0768 221.615 43.2292C221.493 43.3801 221.314 43.5179 221.087 43.6336C220.862 43.7509 220.593 43.8432 220.299 43.9048C220.004 43.9678 219.687 44 219.368 44H27.2326C26.9127 44 26.5968 43.9678 26.3009 43.9048C26.0062 43.8432 25.7381 43.7509 25.5125 43.6336C25.2869 43.5179 25.1077 43.3801 24.9843 43.2292C24.8622 43.0768 24.7998 42.9141 24.7998 42.75V40.25C24.7998 40.0859 24.8622 39.9232 24.9843 39.7708C25.1077 39.6199 25.2869 39.4821 25.5125 39.3649C25.7381 39.2491 26.0062 39.1568 26.3009 39.0952C26.5968 39.0322 26.9127 39 27.2326 39H219.368Z"
          fill="#D9D9D9"
        />
        <path
          d="M184.8 140C185.331 140 185.839 140.13 186.214 140.365C186.589 140.599 186.8 140.919 186.8 141.25V143.75C186.8 143.914 186.749 144.077 186.648 144.229C186.548 144.38 186.4 144.518 186.214 144.634C186.028 144.751 185.808 144.843 185.565 144.905C185.323 144.968 185.062 145 184.8 145H26.8003C26.5373 145 26.2775 144.968 26.0342 144.905C25.7919 144.843 25.5714 144.751 25.3859 144.634C25.2003 144.518 25.053 144.38 24.9515 144.229C24.8511 144.077 24.7998 143.914 24.7998 143.75V141.25C24.7998 141.086 24.8511 140.923 24.9515 140.771C25.053 140.62 25.2003 140.482 25.3859 140.365C25.5714 140.249 25.7919 140.157 26.0342 140.095C26.2775 140.032 26.5373 140 26.8003 140H184.8Z"
          fill="#CBE3FF"
        />
        <path
          d="M238.134 100C238.841 100 239.519 100.13 240.018 100.365C240.519 100.599 240.8 100.919 240.8 101.25V103.75C240.8 103.914 240.731 104.077 240.598 104.229C240.464 104.38 240.267 104.518 240.018 104.634C239.771 104.751 239.477 104.843 239.154 104.905C238.831 104.968 238.483 105 238.134 105H27.4672C27.1165 105 26.7701 104.968 26.4456 104.905C26.1226 104.843 25.8286 104.751 25.5812 104.634C25.3339 104.518 25.1374 104.38 25.0021 104.229C24.8682 104.077 24.7998 103.914 24.7998 103.75V101.25C24.7998 101.086 24.8682 100.923 25.0021 100.771C25.1374 100.62 25.3339 100.482 25.5812 100.365C25.8286 100.249 26.1226 100.157 26.4456 100.095C26.7701 100.032 27.1165 100 27.4672 100H238.134Z"
          fill="#CBE3FF"
        />
        <path
          d="M253.936 59C254.696 59 255.424 59.1304 255.96 59.3649C256.498 59.5993 256.8 59.9173 256.8 60.25V62.75C256.8 62.9141 256.726 63.0768 256.583 63.2292C256.439 63.3801 256.228 63.5179 255.96 63.6336C255.695 63.7509 255.379 63.8418 255.032 63.9048C254.685 63.9678 254.312 64 253.936 64H27.664C27.2879 64 26.9153 63.9678 26.5679 63.9048C26.2204 63.8418 25.9047 63.7509 25.6387 63.6336C25.3726 63.5179 25.1616 63.3801 25.0178 63.2292C24.8739 63.0768 24.7998 62.9141 24.7998 62.75V60.25C24.7998 60.0859 24.8739 59.9232 25.0178 59.7708C25.1618 59.6199 25.3728 59.4821 25.6387 59.3649C25.9047 59.2491 26.2204 59.1568 26.5679 59.0952C26.9153 59.0322 27.2879 59 27.664 59H253.936Z"
          fill="#D9D9D9"
        />
        <path
          d="M157.146 120C157.585 120 158.005 120.13 158.315 120.365C158.626 120.599 158.8 120.917 158.8 121.25V123.75C158.8 123.914 158.757 124.077 158.674 124.229C158.591 124.38 158.469 124.518 158.315 124.634C158.162 124.751 157.979 124.842 157.779 124.905C157.578 124.968 157.363 125 157.146 125H26.4541C26.2369 125 26.0217 124.968 25.821 124.905C25.6203 124.842 25.438 124.751 25.2843 124.634C25.1307 124.518 25.0088 124.38 24.9257 124.229C24.8426 124.077 24.7998 123.914 24.7998 123.75V121.25C24.7998 121.086 24.8426 120.923 24.9257 120.771C25.0089 120.62 25.1308 120.482 25.2843 120.365C25.438 120.249 25.6203 120.157 25.821 120.095C26.0217 120.032 26.2369 120 26.4541 120H157.146Z"
          fill="#D9D9D9"
        />
        <rect
          x="19.125"
          y="21.125"
          width="255.75"
          height="142.75"
          rx="3.875"
          stroke="#94A3B8"
          strokeWidth="0.25"
        />
        <defs>
          <filter
            id="filter0_d_2070_1380"
            x="0.956299"
            y="0.956055"
            width="294.093"
            height="190.708"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={1} dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2070_1380"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2070_1380"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
};

export default BGStep2;
